import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apple-pay',
  templateUrl: './apple-pay.component.html',
  styleUrls: ['./apple-pay.component.css']
})
export class ApplePayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
